import { ICommand } from 'core-ts-types';

export function MySettingsRoutes($urlRouterProvider: ng.ui.IUrlRouterProvider, $stateProvider: ng.ui.IStateProvider) {
  $urlRouterProvider.when('/my/profile/favorites', '/my/settings/favorites/');
  $stateProvider
    .state('my.settings', {
      url: 'settings/',
      templateUrl: 'lib/my_settings/settings.html',
      data: {
        pageTitle: 'Account'
      },
      resolve: {
        contactInfo: (loadContactInfoCommand: ICommand) => {
          return loadContactInfoCommand();
        }
      }
    })
    .state('my.notificationsettings', {
      url: 'notification_settings/',
      views: {
        '@my': {
          templateUrl: 'lib/my_settings/views/notification_settings/notification_settings.html',
          controller: 'NotificationSettingsController',
          controllerAs: '$ctrl'
        }
      },
      data: {
        pageTitle: 'Notification Settings'
      },
      resolve: {
        preferences(loadNotificationSettingsCommand: ICommand) {
          return loadNotificationSettingsCommand().then((model) => model.getAllCategories());
        },
        contactInfo: (loadContactInfoCommand: ICommand) => {
          return loadContactInfoCommand();
        }
      }
    })
    .state('my.contactInformation', {
      url: 'contact-information/',
      templateUrl: 'lib/my_settings/views/notification_settings/contact_information.html',
      data: {
        viewTitle: 'Contact Information'
      }
    })
    .state('my.settings.path-settings', {
      url: 'path_update_topics/',
      views: {
        '@my': {
          template: '<path-preferences all-topics="$resolve.allTopics"></path-preferences>'
        }
      },
      data: {
        pageTitle: 'Todo Topic Settings'
      },
      resolve: {
        allTopics: (loadAllTopicsCommand: ICommand) => {
          return loadAllTopicsCommand();
        }
      }
    })
    .state('my.routeModal.path_preferences_confirm', {
      url: 'path_preferences_confirm/',
      templateUrl: 'lib/my_settings/views/path_preferences_confirm/path_preferences_confirm.html',
      controller: 'PathPreferencesConfirmController',
      controllerAs: '$ctrl'
    });
}



// WEBPACK FOOTER //
// ./app/lib/my_settings/routes.ts